import { NavbarMenuItem } from './NavbarMenuItem';
import MenuRulesPoliciesIcon from '@/assets/images/menu__rules-policies.svg';
import { Collapse, List, ListItemButton, ListItemText, Stack } from '@mui/material';
import { navbarMenuItemMobileText } from './NavbarMenuItem.styles';
import { theme } from '@theme';
import Img from '@barracuda/shared/components/Primitive/Img';
import ArrowUp from '@/assets/images/menu__arrow-up.svg';
import ArrowDown from '@/assets/images/menu__arrow-down.svg';
import { NIcon } from '@barracuda/shared/components/Nemo/NIcon/NIcon';

export interface MenuItemType {
  title: string;
  items: MenuSubItemType[];
  link?: string;
}

export interface MenuSubItemType {
  link: string;
  title: string;
  icon: string | JSX.Element;
  target?: string;
}
const scoreComparisonURI: string = `${process.env.REACT_APP_PESC_URL}${process.env.REACT_APP_PESC_SCORE_COMPARISON_PDF}`;
const iconColor = theme.palette.common.darkGrey12;

const desktopItems: MenuItemType[] = [
  {
    title: 'Students',
    items: [
      {
        link: '/test-format',
        title: 'Test Format',
        icon: <NIcon name='presentation-chart' size='md' color={iconColor} />
      },
      {
        link: '/for-students/institutions',
        title: 'Institutions list',
        icon: <NIcon name='graduation-cap' size='md' color={iconColor} />
      },
      { link: '/policies-rules', title: 'Test Rules and Policies', icon: MenuRulesPoliciesIcon },
      {
        link: scoreComparisonURI,
        target: '_blank',
        title: 'Score guide',
        icon: <NIcon name='file-pdf' size='md' color={iconColor} />
      }
    ]
  },
  {
    title: 'Institutions',
    items: [
      {
        link: '/for-institutions',
        title: 'Accept the test',
        icon: <NIcon name='lightbulb' size='md' color={iconColor} />
      },
      {
        link: '/test-format',
        title: 'Test Format',
        icon: <NIcon name='presentation-chart' size='md' color={iconColor} />
      },
      {
        link: scoreComparisonURI,
        target: '_blank',
        title: 'Score guide',
        icon: <NIcon name='file-pdf' size='md' color={iconColor} />
      }
    ]
  }
];

const mobileItems: MenuItemType[] = [{ title: 'Homepage', items: [], link: '/' }, ...desktopItems];

export const renderDesktopItems = () => {
  return desktopItems.map((item) => (
    <NavbarMenuItem title={item.title} items={item.items} key={`${item.title}`} />
  ));
};
export const renderMobileItems = (
  activeItems: MenuItemType[],
  handleClick: (item: MenuItemType | MenuSubItemType) => void
) => (
  <>
    {mobileItems.map((item, index) => (
      <Stack key={`button-container-${index}`}>
        <ListItemButton
          key={activeItems.includes(item) ? 'active' : 'inactive'}
          sx={{
            background: activeItems.includes(item)
              ? theme.palette.common.monochrome15
              : theme.palette.common.white,
            padding: '16px',
            borderRadius: '4px'
          }}
          onClick={() => handleClick(item)}
        >
          <ListItemText sx={navbarMenuItemMobileText} primary={item.title} />
          {!!item?.items?.length && <Img src={activeItems.includes(item) ? ArrowUp : ArrowDown} />}
        </ListItemButton>
        {!!item?.items?.length &&
          item.items.map((subItem, index) => (
            <Collapse
              key={`collapse-content-${index}`}
              in={activeItems.includes(item)}
              timeout='auto'
              unmountOnExit
            >
              <List component='div' sx={{ padding: 0 }}>
                <ListItemButton
                  sx={{ padding: '16px', borderRadius: '4px' }}
                  onClick={() => handleClick(subItem)}
                >
                  <ListItemText sx={navbarMenuItemMobileText} primary={subItem.title} />
                </ListItemButton>
              </List>
            </Collapse>
          ))}
      </Stack>
    ))}
  </>
);
